import { globalMessages } from '../../../shared/global-message';

export const PROCESSING_FEE_NOTICE_MODAL = {
  type: globalMessages.modalTypeActionDialog,
  imageSrc: globalMessages.iconExclamationOctagonOrange,
  message: globalMessages.modalProcessingFeeTitle,
  messageExt: globalMessages.modalProcessingFeeBody,
  confirm: globalMessages.modalConfirmContinue,
  cancel: globalMessages.modalProcessingFeeCancel,
  fields: [],
};

export const DELETE_PAYMENT_MODAL = {
  type: globalMessages.modalTypeActionDialog,
  imageSrc: globalMessages.iconExclamationOctagonOrange,
  message: globalMessages.modalDeletePaymentTitle,
  messageExt: globalMessages.modalDeletePaymentBody,
  confirm: globalMessages.modalConfirmDelete,
  cancel: globalMessages.modalCancelGoBack,
  fields: [],
};

export const AUTH_REQUIRED_MODAL = {
  type: globalMessages.modalTypeActionDialog,
  imageSrc: globalMessages.iconExclamationOctagonOrange,
  message: '',
  messageExt: globalMessages.modalAuthRequiredBody,
  confirm: globalMessages.modalConfirmContinue,
  cancel: globalMessages.modalCancelCancel,
  fields: [],
};
